import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { formatPrice } from "../../../../services/helpers/Helper";
import { deleteProductCampaign, updateProductCampaign } from "../../../../store/action/campaignsAction";
const _ = require('lodash');

const FormEditProduct = (props) => {
   const params = useParams();
   const { id } = params;
   const { campaign, product, deleteProductCampaign, onClose, updateProductCampaign } = props;
   const [isEditName, setIsEditName] = useState(false);
   const [formSubmit, setFormSubmit] = useState({ ...product });
   const [error, setError] = useState({
      product_selling_price: '',
      keywords: '',
      product_name: ''
   });

   const onChange = (e) => {
      const name = e.target.name;
      let value = e.target.value;

      setFormSubmit(oldValue => {
         if (name == 'product_selling_price' || name == 'product_original_price' || name == 'product_unit' || name == 'purchase_limits') {
            // value = _.replace(value, /\D/g, '');
            // moveCursorBeforCharacter(e);
         }
         if (name == 'product_code') {
            oldValue.keywords = [{
               campaigns_manage_id: id,
               keyword: value
            }];
         }

         oldValue = { ...oldValue, [name]: value };
         return { ...oldValue };
      });
   }

   const handleUpdateProduct = () => {
      if (!!error.keywords || !!error.product_selling_price || !!error.product_name) {
         return;
      }
      const data = {
         campaigns_manage_id: formSubmit.campaigns_manage_id,
         is_active: formSubmit.is_active,
         id: formSubmit.id,
         product_selling_price: formSubmit.product_selling_price,
         purchase_limits: formSubmit.purchase_limits,
         product_code: formSubmit.keywords.map((m) => m.keyword).join(" "),
         product_name: formSubmit.product_name,
         product_unit: formSubmit.product_unit,
         product_original_price: formSubmit.product_original_price,
         keywords: formSubmit.keywords,
      }
      updateProductCampaign(data);
      onClose();
   }

   const handleSetKeyword = (e) => {
      const value = e.target.value;
      if (e.keyCode == 13 && value) {
         setFormSubmit(oldValue => {
            if (!oldValue.keywords) {
               oldValue.keywords = [{
                  campaigns_manage_id: id,
                  keyword: value
               }];
            } else {
               oldValue.keywords = [...oldValue.keywords, {
                  campaigns_manage_id: id,
                  keyword: value
               }];
            }
            return { ...oldValue };
         });
         e.target.value = '';
      }
   }

   const onRemoveKeyword = (index) => {
      setFormSubmit(oldValue => {
         oldValue.keywords = oldValue.keywords.filter((f, i) => i !== index);
         return { ...oldValue };
      });
   }

   useEffect(() => {
      let error = false;
      let listKey = []
      try {
         campaign?.products?.map((m) => {
            if (m.id != product.id) {
               m.keywords.map((m2) => {
                  listKey.push(m2.keyword);
               });

            }
         });
      } catch (error) {

      }

      if (formSubmit?.keywords?.length == 0) {
         setError(oldValue => {
            return {
               ...oldValue,
               keywords: "Vui lòng nhập thêm mã"
            }
         });
         error = true;
      } else {
         const listKey2 = formSubmit?.keywords?.map((m) => m.keyword);
         if (listKey.some(s => listKey2.includes(s)) || listKey2.length !== new Set(listKey2).size) {
            setError(oldValue => {
               return {
                  ...oldValue,
                  keywords: "Mã đã tồn tại"
               }
            });
            error = true;
         }
      }

      if (!formSubmit.product_selling_price) {
         setError(oldValue => {
            return { ...oldValue, product_selling_price: "Vui lòng nhập giá bán" }
         });
         error = true;
      }

      if (!formSubmit.product_name) {
         setError(oldValue => {
            return { ...oldValue, product_name: "Vui lòng nhập tên sản phẩm" }
         });
         error = true;
      }

      if (!error) {
         setError({
            product_selling_price: '',
            keywords: ''
         })
      }
   }, [formSubmit]);

   const moveCursorBeforCharacter = (e) => {
      const pos = e.target.value.indexOf('đ');
      if (pos !== -1) {
         e.target.selectionStart = e.target.selectionEnd = pos - 1;
      }
   }

   return (
      <div className="app-popover livestream-popover-edit-product app-popover-placement-bottom">
         <div className="app-popover-content">
            <div className="app-popover-inner" role="tooltip">
               <div>
                  <div className="app-popover-inner-content">
                     <div>
                        <div className="popup-edit-product">
                           <div className="body">
                              <div className="product-name display-flex transition">
                                 <div className="photo border-radius4 disable-select">
                                    <div className="default d-flex-center">
                                       <div className="svg-next-icon image-default-v2">
                                       </div>
                                    </div>
                                 </div>
                                 <div className="info-container ml16">
                                    <div>
                                       <div className={!!error.product_name && "error-new"}>
                                          <span className="breadcrumb-edit-inline-wrapper">
                                             {isEditName ?
                                                <input
                                                   type="text"
                                                   className="app-next-input"
                                                   name="product_name"
                                                   autoFocus value={formSubmit.product_name}
                                                   onChange={onChange}
                                                   onBlur={() => {
                                                      if (!error.product_name) {
                                                         setIsEditName(false)
                                                      }
                                                   }}
                                                />
                                                :
                                                <div >
                                                   <span className="line-title" title={formSubmit.product_name}>
                                                      {formSubmit.product_name}
                                                   </span>
                                                   <button type="button" className="app-btn app-btn-link app-btn-pd-none" onClick={() => setIsEditName(true)}>
                                                      <div className="svg-next-icon ml10 ic-edit-one-line" >
                                                      </div>
                                                   </button>
                                                </div>
                                             }
                                          </span>
                                          {!!error.product_name &&
                                             <div className="inline-error mt8 line-height-20" title={error.product_name}>{error.product_name}</div>
                                          }
                                       </div>
                                       <div className="optional-value ellipsis line-height-16 font-size-12 mt6">
                                          <span className="cursor-auto">
                                             <span className="ellipsis-space-pre italic" title="Sản phẩm tùy biến">Sản phẩm tùy biến</span>
                                          </span>
                                       </div>
                                    </div>

                                 </div>
                              </div>
                              <div className="edit-section">
                                 <div className="item-wrapper ellipsis multi-keyword">
                                    <div className="d-flex items-center">
                                       <span className="title ellipsis" title="Mã sản phẩm">
                                          Mã sản phẩm
                                       </span>
                                       <span className="required">*</span>
                                       <span className="pointer ml4">
                                          <div className="svg-next-icon mb-3 ic-help" >
                                          </div>
                                       </span>
                                    </div>
                                    <div className="input-children">
                                       <div className="col-keyword">
                                          <div className={`input-keyword ${!!error.keywords && "border-error"}`}>
                                             {formSubmit?.keywords?.map((item, index) => {
                                                return (
                                                   <div className="app-badges app-badges--status-primary-string input-keyword__badges" onClick={() => onRemoveKeyword(index)} key={index}>
                                                      <div className="app-badges-body" >
                                                         <span className="text-nowrap content" title={item.keyword}>
                                                            {item.keyword}
                                                         </span>
                                                         <div className="pointer button-delete">
                                                            <div>
                                                               <div className="svg-next-icon next-close-2">
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                )
                                             })}
                                             <input className="input-keyword__text text-no-bold" onKeyDown={handleSetKeyword} />
                                          </div>
                                          {!!error.keywords && <div className="inline-error mt8 line-height-20" title={error.keywords}>{error.keywords}</div>}
                                       </div>
                                    </div>
                                 </div>
                                 <div className="item-wrapper ellipsis">
                                    <div className="d-flex items-center">
                                       <span className="title ellipsis" title="Giá bán">
                                          Giá bán
                                       </span>
                                       <span className="required">*</span>
                                    </div>
                                    <div className="input-children">
                                       <div className="col-price">
                                          <div className={`display-flex border-radius4 input-with-icon ${!!error.product_selling_price && "border-error-new"}`}>
                                             <div className="input-container">
                                                <input
                                                   type="text"
                                                   name="product_selling_price"
                                                   value={formSubmit.product_selling_price}
                                                   onChange={onChange}
                                                />
                                             </div>
                                             <div className="right-icon">
                                                <div className="svg-next-icon pointer ic-modal-close-2">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       {!!error.product_selling_price && <div className="inline-error mt8 line-height-20" title={error.product_selling_price}>{error.product_selling_price}</div>}
                                    </div>
                                 </div>
                                 <div className="item-wrapper ellipsis">
                                    <div className="d-flex items-center">
                                       <span className="title ellipsis" title="Giá gốc">
                                          Giá gốc
                                       </span>
                                    </div>
                                    <div className="input-children">
                                       <div className="col-price">
                                          <div className="display-flex border-radius4 input-with-icon">
                                             <div className="input-container">
                                                <input type="text"
                                                   name="product_original_price"
                                                   value={formSubmit.product_original_price}
                                                   onChange={onChange}
                                                />
                                             </div>
                                             <div className="right-icon">
                                                <div className="svg-next-icon pointer ic-modal-close-2">
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="item-wrapper ellipsis">
                                    <div className="d-flex items-center">
                                       <span className="title ellipsis" title="Số lượng mở bán">
                                          Số lượng mở bán
                                       </span>
                                       {/* <span className="pointer ml4">
                                          <div className="svg-next-icon mb-3 ic-help">
                                          </div>
                                       </span> */}
                                    </div>
                                    <div className="input-children">
                                       <div className="col-quantity">
                                          <div className="display-flex border-radius4 input-with-icon">
                                             <div className="input-container">
                                                <input type="text" name="product_unit" value={formSubmit.product_unit} onChange={onChange} />
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="item-wrapper ellipsis">
                                    <div className="d-flex items-center">
                                       <span className="title ellipsis" title="Giới hạn mua /1 khách">
                                          Giới hạn mua /1 khách
                                       </span>
                                      
                                    </div>
                                    <div className="input-children">
                                       <div className="col-price">
                                          <div className="display-flex border-radius4 input-with-icon">
                                             <div className="input-container">
                                                <input type="text" name="purchase_limits" value={formSubmit.purchase_limits} onChange={onChange} />
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className="footer">
                              <div className="edit-product-delete" onClick={() => { deleteProductCampaign([formSubmit.id]); onClose(); }}>
                                 <button type="button" className="app-btn app-btn-link app-btn-pd-none">
                                    <span>
                                       <div className="svg-next-icon ic-recycle-bin-two-lines-new">
                                       </div>
                                    </span>
                                    <span className="ml4 mt1 ">Xóa khỏi danh sách</span>
                                 </button>
                              </div>
                              <div>
                                 <button type="button" className="app-btn app-btn-default app-v2-btn-default" onClick={onClose}>
                                    Hủy
                                 </button>
                                 <button type="button" className="app-btn app-btn-primary ml12" onClick={handleUpdateProduct} disabled={!!error.keywords || !!error.product_selling_price || !!error.product_name}>
                                    <div className="svg-next-icon mr8 mb2 ic-save-outline-white-2">
                                    </div>
                                    Lưu thay đổi
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { campaign } = state;
   return {
      campaign
   };
};


export default connect(mapStateToProps, {
   deleteProductCampaign,
   updateProductCampaign
})(FormEditProduct)
